class List {
    defaultOptions() {
        return {
            '$container': null,
            'onClickNext': function () {
            },
            'urlDetail': '/competition/detail'
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        this.response = null;
        this.data = this.settings.data;
        this.needClear = true;

        this.initialize();
    }


    setNeedClear(value) {
        this.needClear = value;
    }

    initialize() {

    }

    setData(xhr) {
        this.response = xhr;
        this.data = xhr.data;
        this.build();
    }

    build() {

        if (this.needClear) {
            this.$container
            .html('');
            this.$list = $('<ul/>')
            .addClass('competition-list')
            .appendTo(this.$container);
        } else {
            this.removeNextButton();
        }


        for (var i in this.data) {
            let item = this.data[i];

            let $item = this.buildItem(item);

            this.$list.append($item);
        }

        if (this.response.hasNext) {
            let $next = this.buildNextButton();
            this.$list.append($next);
        }
    }

    buildItem(item) {
        let $item = $('<li/>')
        .addClass('competition-list-item');

        let $name = $('<div/>')
        .addClass('competition-name')
        .append(
            $('<i/>')
            .addClass('icon icon-competition')
        )
        .append(
            $('<div/>')
            .addClass('value')
            .append(item.Nom)
        );

        let $organisme = $('<div/>')
        .addClass('competition-organisme')
        .append(
            $('<i/>')
            .addClass('icon icon-club')
        )
		.append(
			$('<span/>')
			.addClass('label')
			.append("Organisateur")
		)
        .append(
            $('<div/>')
            .addClass('value')
            .append(item.Organisme.label)
        );

        let $place = $('<div/>')
        .addClass('competition-place')
		.append(
			$('<i/>')
			.addClass('icon icon-marker')
		)
		.append(
			$('<span/>')
			.addClass('label')
			.append("Lieu")
		)
		.append(
			$('<div/>')
			.addClass('value')
			.append(item.Lieu)
		);

        let $engagement = $('<div/>')
        .addClass('competition-engagement')
		.append(
			$('<i/>')
			.addClass('icon icon-engagement')
		)
		.append(
			$('<span/>')
			.addClass('label')
			.append("Engagements")
		)
		.append(
			$('<div/>')
			.addClass('value')
			.append(item.engagementLabel)
		);

        let $period = $('<div/>')
        .addClass('competition-period')
		.append(
			$('<i/>')
			.addClass('icon icon-calendar')
		)
		.append(
			$('<span/>')
			.addClass('label')
			.append("P&eacute;riode")
		)
		.append(
			$('<div/>')
			.addClass('value')
			.append(item.dateLabel)
		);

        let $speciality = $('<div/>')
        .addClass('competition-speciality')
		.append(
			$('<i/>')
			.addClass('icon icon-speciality')
		)
		.append(
			$('<span/>')
			.addClass('label')
			.append("Sp&eacute;cialit&eacute;")
		)
		.append(
			$('<div/>')
			.addClass('value')
			.append(item.specialiteLabel)
		);

        let $typeBassin = $('<div/>')
        .addClass('competition-bassin')
		.append(
			$('<i/>')
			.addClass('icon icon-bassin')
		)
		.append(
			$('<span/>')
			.addClass('label')
			.append("Bassin")
		)
		.append(
			$('<div/>')
			.addClass('value')
			.append(item.bassin)
		);

        let $typeWater = $('<div/>')
        .addClass('competition-water')
		.append(
			$('<i/>')
			.addClass('icon icon-wave')
		)
		.append(
			$('<span/>')
			.addClass('label')
			.append("Plan d'eau")
		)
		.append(
			$('<div/>')
			.addClass('value')
			.append(item.water)
		);

        let iconClass = 'icon-plus-circle';
        let btnLabel = 'Voir d&eacute;tails';
        if (item.hasResultat) {
            $item.addClass('has-result');
            btnLabel = 'Voir r&eacute;sultats';
            iconClass = 'icon-arrow-circle-right';
        }

        let $btnDetail = $('<a/>')
        .attr('href', this.settings.urlDetail + "?id=" + item.Id)
        .addClass('btn btn-text btn-icon text-primary btn-competition-detail')
        .append(btnLabel)
        .append(
            $('<i/>')
            .addClass('icon')
            .addClass(iconClass)
        );


        let $content = $('<div/>')
        .addClass('competition')
        .addClass('row')
        .append(
            $('<div/>')
            .addClass('col-12 col-md-4 col-xl-2 competition-slot-name')
            .append(
                $name
            )
        )
        .append(
            $('<div/>')
            .addClass('col-12 col-md-8 col-xl-10')
            .append(
                $('<div/>')
                .addClass('row competition-slot-list')
                .append(
                    $('<div/>') 
                    .addClass('competition-slot-item col-12 col-md-6 col-xl-4')
                    .append(
                        $organisme
                    )
                )
                .append(
                    $('<div/>')
                    .addClass('competition-slot-item col-12 col-md-6 col-xl-2')
                    .append(
                        $place
                    )
                )
                .append(
                    $('<div/>')
                    .addClass('competition-slot-item col-12 col-md-6 col-xl-3')
                    .append(
                        $engagement
                    )
                )
                .append(
                    $('<div/>')
                    .addClass('competition-slot-item col-12 col-md-6 col-xl-3')
                    .append(
                        $period
                    )
                )
                .append(
                    $('<div/>')
                    .addClass('competition-slot-item col-12 col-md-6 col-xl-3')
                    .append(
                        $speciality
                    )
                )
                .append(
                    $('<div/>')
                    .addClass('competition-slot-item col-12 col-md-6 col-xl-3')
                    .append(
                        $typeBassin
                    )
                )
                .append(
                    $('<div/>')
                    .addClass('competition-slot-item col-12 col-md-6 col-xl-3')
                    .append(
                        $typeWater
                    )
                )
                .append(
                    $('<div/>')
                    .addClass('competition-slot-item-action col-12 col-md-6 col-xl-3')
                    .append(
                        $('<div/>')
                        .addClass('d-flex justify-content-center ')
                        .append(
                            $btnDetail
                        )
                    )
                )
            )
        );


        $item.append($content);


        return $item;
    }

    removeNextButton() {
        $('.competition-list-item-btn', this.$list).remove();
    }

    buildNextButton() {
        var self = this;
        let $item = $('<li/>')
        .addClass('competition-list-item-btn');


        let $btnNext = $('<button/>')
        .addClass('btn btn-primary btn-next')
        .attr('data-value', this.response.next)
        .append("Voir plus (" + this.response.remains + ')')
        .on('click', function () {
            let $btn = $(this);
            $btn.attr('disabled', 'disabled');
            $btn.html('')
            .append(
                $('<i/>')
                .addClass('fa fa-spin fa-spinner')
            )
            self.settings.onClickNext($btn.data('value'))
        });

        $item.append($btnNext);

        return $item;

    }

}

module.exports = List;